module.exports = __webpack_public_path__ + "static/img/37.1d063b60.png";